import NonCategoryProductList from './NonCategoryProductList';
import NonCategoryProductEdit from './NonCategoryProductEdit';
import NonCategoryProductCreate from "./NonCategoryProductCreate";

export default {
    list: NonCategoryProductList,
    edit: NonCategoryProductEdit,
    create: NonCategoryProductCreate,
};
